// import {Component, Input, OnDestroy, OnInit} from '@angular/core';
//
// import { Subscription } from 'rxjs';
//
// import { AuthService } from '../../../account/shared/auth.service';
//
// import { User } from '../../../models/user.model';
// import {ProductService} from '../../../my-products/shared/product.service';
//
//
// @Component({
//   selector: 'app-navigation-main',
//   templateUrl: './navigation-main.component.html',
//   styleUrls: ['./navigation-main.component.scss']
// })
// export class NavigationMainComponent implements OnInit, OnDestroy {
//   public user: User;
//   private authSubscription: Subscription;
//   public families : string[] = []
//   public isMobileMenuOpen: boolean = false; // Added missing property
//
//   constructor(public authService: AuthService,
//               private productService : ProductService
//               ) {}
//
//   ngOnInit() {
//     this.authService.user.subscribe((user) => {
//       this.user = user;
//     });
//     this.productService.getFamilies().subscribe(families => {
//       console.log('families ',families)
//       this.families = families;
//       this.families.push(...['PARFUMS', 'COFFRETS', 'PROMOTIONS', 'MAQUILLAGE', 'SOINS', 'CHEVEUX', 'ACCESSOIRES', 'IDEES CADEAUX']);
//     });
//
//
//
//   }
//
//
//
//   ngOnDestroy() {
//     this.authSubscription.unsubscribe();
//   }
// }


import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../account/shared/auth.service';
import { ProductService } from '../../../my-products/shared/product.service';
import {User} from '../../../models/user.model';
import {UpperCasePipe} from '@angular/common';

@Component({
  selector: 'app-navigation-main',
  templateUrl: './navigation-main.component.html',
  styleUrls: ['./navigation-main.component.scss']
})
export class NavigationMainComponent implements OnInit, OnDestroy {
  @Input() isMobileMenuOpen: boolean = false;
  public user: User;
  private authSubscription: Subscription;
  public families: string[] = [];

  constructor(
    public authService: AuthService,
    private productService: ProductService
  ) {}

  ngOnInit() {
   /* this.authService.user.subscribe((user) => {
      this.user = user;
    });*/
    this.productService.getFamilies().subscribe(families => {
      console.log('families ', families);
      this.families = families;
    //  this.families.push(...['PARFUMS', 'COFFRETS', 'PROMOTIONS', 'MAQUILLAGE', 'SOINS', 'Cheveux', 'ACCESSOIRES', 'IDEES CADEAUX']);
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
